import React from 'react';
import { Skeleton } from '../index';

import {
  TicketCard,
  TicketRow,
  TicketPreview,
  TicketContainer,
  TicketHeader,
  TicketHeading,
  TicketPrice,
} from './styles';

const GhostTicket = () => (
  <TicketCard>
    <TicketRow>
      <TicketPreview>
        <Skeleton />
      </TicketPreview>
      <TicketContainer>
        <TicketHeader>
          <Skeleton />
        </TicketHeader>
        <TicketHeading>
          <Skeleton />
        </TicketHeading>
        <TicketPrice>
          <Skeleton />
        </TicketPrice>
      </TicketContainer>
    </TicketRow>
    <TicketRow>
      <Skeleton height={20} />
    </TicketRow>
  </TicketCard>
);

export default GhostTicket;
